import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State, state } from './state';
import { Mutations } from './mutations';
import { GridActionTypes } from "./action-types";
import { SegNotificacaoModel } from '@/models/message/seg-notificacao.model';
import { GridMutationTypes } from './mutation-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [GridActionTypes.SET_FILTER](
    { commit }: AugmentedActionContext,
    params: {
      grid: string,
      filters: any
    }
  ): void;
  [GridActionTypes.SET_VIEW](
    { commit }: AugmentedActionContext,
    params: {
      grid: string,
      viewId: any
    }
  ): void;
  [GridActionTypes.ADD_VIEW](
    { commit }: AugmentedActionContext,
    params: {
      grid: string,
      view: any
    }
  ): void;
  [GridActionTypes.CLEAR_VIEWS](
    { commit }: AugmentedActionContext,
    params: {
      grid: string
    }
  ): void;
  [GridActionTypes.DELETE_VIEW](
    { commit }: AugmentedActionContext,
    params: {
      grid: string,
      viewId: string
    }
  ): void;
  [GridActionTypes.SET_ORDER](
    { commit }: AugmentedActionContext,
    params: {
      grid: string,
      order: string,
      orderType: string
    }
  ): void;

  [GridActionTypes.SET_PAGE](
    { commit }: AugmentedActionContext, params: {
      grid: string,
      page: number
    }): void;

  [GridActionTypes.SET_COLUMN_WIDTH](
    { commit }: AugmentedActionContext, params: {
      grid: string,
      datafield: string,
      width: number
    }): void;

  [GridActionTypes.CLEAR_ORDER]({ commit }: AugmentedActionContext, params: {
    grid: string
  }): void

  [GridActionTypes.CLEAR_GRID]({ commit }: AugmentedActionContext, params: {
    grid: string
  }): void;

  [GridActionTypes.CLEAR_PAGE]({ commit }: AugmentedActionContext, params: {
    grid: string
  }): void;

  [GridActionTypes.CLEAR_ALL_GRIDS]({ commit }: AugmentedActionContext): void;

  [GridActionTypes.CLEAR_FILTERS]({ commit }: AugmentedActionContext, params: {
    grid: string
  }): void
}


export const actions: ActionTree<State, RootState> & Actions = {
  [GridActionTypes.SET_FILTER]({ commit }, params: {
    grid: string,
    filters: any
  }) {

    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    obj[params.grid].filters = params.filters;

    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.SET_VIEW]({ commit }, params: {
    grid: string,
    viewId: any
  }) {

    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

      obj[params.grid].selectedView = params.viewId;

    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.ADD_VIEW]({ commit }, params: {
    grid: string,
    view: any
  }) {

    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    if(obj[params.grid]&&!obj[params.grid].views)
      obj[params.grid].views = [];

    obj[params.grid].views.push(params.view);

    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.DELETE_VIEW]({ commit }, params: {
    grid: string,
    viewId: string
  }) {

    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    const item = obj[params.grid].views.indexOf(obj[params.grid].views.find((x:any)=> x.viewId == params.viewId));
    if(item>=0)
    obj[params.grid].views.splice(item, 1);
    

    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  
  [GridActionTypes.CLEAR_VIEWS]({ commit }, params: {
    grid: string
  }) {

    const obj = Object.assign({}, state.grids) as any;
    obj.views = [];
    

    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.SET_ORDER]({ commit }, params: {
    grid: string,
    order: string,
    orderType: string
  }) {

    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    obj[params.grid].order = params.order;
    obj[params.grid].orderType = params.orderType;


    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.SET_PAGE]({ commit }, params: {
    grid: string,
    page: number
  }): void {
    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    obj[params.grid].page = params.page;


    commit(GridMutationTypes.SET_GRIDS, obj);
  },

  [GridActionTypes.SET_COLUMN_WIDTH]({ commit }, params: {
    grid: string,
    datafield: string,
    width: number
  }): void {
    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    if (!obj[params.grid].columnWidths)
      obj[params.grid].columnWidths = {};

    obj[params.grid].columnWidths[params.datafield] = params.width;

    commit(GridMutationTypes.SET_GRIDS, obj);
  },

  [GridActionTypes.CLEAR_ALL_GRIDS]({ commit }): void {
    commit(GridMutationTypes.SET_GRIDS, {});
  },
  [GridActionTypes.CLEAR_FILTERS]({ commit }, params: {
    grid: string
  }): void {
    const obj = Object.assign({}, state.grids) as any;

    if (!obj[params.grid])
      obj[params.grid] = {};

    obj[params.grid].filters = [];

    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.CLEAR_GRID]({ commit }, params: {
    grid: string
  }): void {
    const obj = Object.assign({}, state.grids) as any;

    if (obj[params.grid]) {
      delete obj[params.grid];
    }
    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.CLEAR_ORDER]({ commit }, params: {
    grid: string
  }): void {
    const obj = Object.assign({}, state.grids) as any;

    if (obj[params.grid]) {
      obj[params.grid].order = '';
      obj[params.grid].orderType = '';
    }
    commit(GridMutationTypes.SET_GRIDS, obj);
  },
  [GridActionTypes.CLEAR_PAGE]({ commit }, params: {
    grid: string
  }): void {
    const obj = Object.assign({}, state.grids) as any;

    if (obj[params.grid])
      obj[params.grid].page = null;

    commit(GridMutationTypes.SET_GRIDS, obj);
  },

  [GridActionTypes.GET_GRID]({ commit },grid:string): any {
    return state.grids[grid];
  },

};
